import { cn } from '@/lib/utils'
import { DashboardHeader } from './dashboard-header'
import { DashboardSideBar } from './dashboard-sidebar'
import { Outlet } from 'react-router-dom'
import { WarningIcon } from '../ui/icon'
import { agentsHooks } from '@/manager'
import { useTranslation } from 'react-i18next'

export const AgentDashboard = () => {
  const { t } = useTranslation();
  const { isAgentExpired } = agentsHooks.useGetCurrentAgent();

  return (
    <div className='w-full h-screen flex flex-col flex-1 overflow-hidden'>
      {isAgentExpired && <ExpirationWarning />}
      <DashboardHeader />
      <main className={cn("flex flex-1 bg-white overflow-hidden")}>
        <DashboardSideBar />
        <div className='flex-1 min-w-0 px-8 pt-6 pb-4 overflow-auto'>
          <Outlet />
        </div>
      </main>
    </div>
  )
}

/** 到期警告 */
const ExpirationWarning = () => {
  const { t } = useTranslation();

  return (
    <div className='w-full h-[52px] flex items-center justify-center bg-[rgba(220,104,3,1)]/10'>
      <div className='flex items-center gap-3 text-[rgba(220,104,3,1)]'>
        <WarningIcon className='size-5 text-[rgba(220,104,3,1)]' />
        <span className='text-sm'>{t('agent_dashboard.expired_banner')}</span>
      </div>
    </div>
  )
}
